module.exports = __webpack_public_path__ + "static/media/tray9.6b5f988d.png";